import React from "react";
import { Check, Clock, X } from "lucide-react";
import { ORDER_STATUSES } from "@/lib/bd";

export const OrderTimeline = ({ status }) => {
  if (status === "cancelled") {
    return (
      <div className="flex items-center gap-2 bg-red-50 text-red-700 rounded-xl p-4 border border-red-200">
        <X size={20} /> <span className="font-semibold">এই অর্ডারটি বাতিল করা হয়েছে</span>
      </div>
    );
  }
  const currentIdx = ORDER_STATUSES.findIndex((s) => s.key === status);
  return (
    <div className="relative">
      {ORDER_STATUSES.map((s, i) => {
        const done = i < currentIdx;
        const active = i === currentIdx;
        return (
          <div key={s.key} className="flex gap-3 pb-6 last:pb-0 relative" data-testid={`timeline-${s.key}`}>
            {i < ORDER_STATUSES.length - 1 && (
              <div className={`absolute left-[15px] top-8 w-0.5 h-full ${done ? "bg-emerald-500" : "bg-stone-200"}`} />
            )}
            <div className={`w-8 h-8 rounded-full flex items-center justify-center shrink-0 z-10 ${
              done ? "bg-emerald-500 text-white" : active ? "bg-[#CA8A04] text-white ring-4 ring-amber-100" : "bg-stone-200 text-stone-400"}`}>
              {done ? <Check size={16} /> : active ? <Clock size={16} /> : <span className="text-xs">{i + 1}</span>}
            </div>
            <div className="pt-1">
              <div className={`font-semibold ${done || active ? "text-[#1E3A2B]" : "text-stone-400"}`}>{s.label}</div>
              {active && <div className="text-xs text-[#CA8A04] font-medium">বর্তমান অবস্থা</div>}
            </div>
          </div>
        );
      })}
    </div>
  );
};
